import CsiFormData from "csi/action/FormData";
import Action from "csi/def/Action";
import GoToDialogStore from "csi/middleware/goToDialog/GoToDialogStore";
import { buildFormData, openSelectionDialogFromCNLs } from "csi/middleware/goToDialog/goToDialogService";
import { TABLE_ID } from "csi/service/viewService";
import WorkingCache from "csi/state/WorkingCache";
import { routerStore } from "csi/state/rootStore";
import { C8Node, C8NodeType, ICache, cnl } from "csi/typings";

type GoToDialogSelectionCallback = (url: cnl[]) => void;
export class GoToDialogHelper {
	/** cache for the dialog we will be creating and using */
	readonly cache: ICache;

	/** formData for the dialog we will be creating and using */
	readonly formData: CsiFormData;

	/** true if you would like the GoToDialog to be multiselect, otherwise false */
	readonly multiSelect: boolean;

	/** node type we want on our new view */
	readonly nodeType: C8NodeType;

	/** 
	 * this is a callback function that will be called after the selection is finished.
	 * This will be for viewing what was picked inside of the GoToDialog while it was active
	 */
	private onSelectionUpdated: GoToDialogSelectionCallback;

	/** this will be our GoToDialogStore that we can access from other places to view data */
	goToDialogStore: GoToDialogStore;

	/** onSave for form */
	saveSelectionDialog = (): void => {
		routerStore.closeInlineDialog();
		if (this.onSelectionUpdated) {
			const viewItems = this.goToDialogStore.selectionsByGroup[TABLE_ID];
			// function you declare is called after the dialog is closed, no more edits will be made to it after this
			const itemCNLs = viewItems.map((viewItems) => viewItems.$id);
			this.onSelectionUpdated(itemCNLs);
		}
	};

	/**
	 * This will open a goToDialog for a given set of CNLs
	 * @param resultUrls - The cnls of the nodes you would like displayed in your view
	 * @param currentSelectionsCNL - optional, this is a list of CNLs you would like to display as selected in your view
	 * @param disabledIds - optional, set of ids whose selection should be disabled
	 */
	openGoToDialogWithCNLs = (resultUrls: cnl[], currentSelections?: C8Node[], disabledIds?: Set<string>): void => {
		const { cache, formData, saveSelectionDialog, nodeType, multiSelect } = this;
		formData.m_bAllowSelections = true;
		formData.m_bSelectOne = !multiSelect;

		// if currentSelections are being used, reset selections to avoid conflicts with preset selections and set them to what is currently selected
		if (currentSelections) {
			formData.resetAggregations();
			formData.resetSelections();
			currentSelections.forEach((node) => {
				formData.addAggregatedNode(node);
				formData.getCache()
					.cacheNode(node);
			});
			formData.m_fAggregateTest = (ctx): boolean => !disabledIds?.has(ctx.getNodeURL());
		}

		this.goToDialogStore = openSelectionDialogFromCNLs(resultUrls, formData, nodeType, routerStore.locationUrl, saveSelectionDialog, cache, multiSelect);
	};

	constructor(nodeType: C8NodeType, multiSelect: boolean, onSelectionUpdated: GoToDialogSelectionCallback) {
		this.cache = new WorkingCache();
		this.formData = buildFormData(new Action(), this.cache);
		this.nodeType = nodeType;
		this.multiSelect = multiSelect;
		this.onSelectionUpdated = onSelectionUpdated;
	}
}